export enum AccountKind {
  Customer = "customer",
  SwivlStaff = "swivl_staff",
  SwivlAdmin = "swivl_admin"
}

export const SWIVL_STAFF_KINDS: ReadonlyArray<AccountKind> = [AccountKind.SwivlStaff, AccountKind.SwivlAdmin];
